/**
 * Toast 通知管理器
 * 提供全局的 toast 通知功能
 */

class ToastManager {
  constructor() {
    this.listeners = new Set();
    this.notices = [];
    this.noticeIdCounter = 0;
  }

  /**
   * 添加通知監聽器
   * @param {Function} listener - 監聽器函數
   */
  addListener(listener) {
    this.listeners.add(listener);
  }

  /**
   * 移除通知監聽器
   * @param {Function} listener - 監聽器函數
   */
  removeListener(listener) {
    this.listeners.delete(listener);
  }

  /**
   * 顯示 toast 通知
   * @param {string} message - 通知消息
   * @param {string} type - 通知類型 ('success', 'error', 'warning', 'info')
   * @param {number} duration - 顯示時長（毫秒），預設 5000
   */
  show(message, type = 'info', duration = 5000) {
    const id = ++this.noticeIdCounter;
    const notice = { id, message, type };

    this.notices.push(notice);
    this.notifyListeners();

    // 自動移除通知
    if (duration > 0) {
      setTimeout(() => {
        this.remove(id);
      }, duration);
    }

    return id;
  }

  /**
   * 移除通知
   * @param {number} id - 通知ID
   */
  remove(id) {
    this.notices = this.notices.filter(notice => notice.id !== id);
    this.notifyListeners();
  }

  /**
   * 移除所有通知
   */
  clear() {
    this.notices = [];
    this.notifyListeners();
  }

  /**
   * 通知所有監聽器
   */
  notifyListeners() {
    this.listeners.forEach(listener => {
      listener([...this.notices]);
    });
  }

  /**
   * 獲取當前所有通知
   * @returns {Array} 通知列表
   */
  getNotices() {
    return [...this.notices];
  }

  // 便利方法
  success(message, duration = 5000) {
    return this.show(message, 'success', duration);
  }

  error(message, duration = 5000) {
    return this.show(message, 'error', duration);
  }

  warning(message, duration = 5000) {
    return this.show(message, 'warning', duration);
  }

  info(message, duration = 5000) {
    return this.show(message, 'info', duration);
  }
}

// 創建單例實例
const toastManager = new ToastManager();

export default toastManager;
